module.exports = __webpack_public_path__ + "img/CRT_Spear-003.5a1ac85e.png";